import { Component, OnInit, Input } from '@angular/core';
import { BracketRound, DataService } from 'src/app/services/data-service.service';

@Component({
  selector: 'dmk-round',
  templateUrl: './dmk-round.component.html',
  styleUrls: ['./dmk-round.component.scss'],
  host: {
    '(window:resize)': 'displayHeaders($event)'
  }
})
export class DmkRoundComponent implements OnInit {
  @Input() round: BracketRound;

  constructor(public ds: DataService) { }

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.displayHeaders();
  }

  public displayHeaders(): void {
    for (let i = 0; i < this.round.matches.length; i++) {
      this.round.matches[i].showHeaders = false;
      if ((this.ds.mobile || this.round.matches.length < 5) && i === 0) {
        this.round.matches[i].showHeaders = true;
      } else if (!this.ds.mobile && this.round.matches.length > 4 && (i === 0 || i === 1)) {
        this.round.matches[i].showHeaders = true;
      }
    }
  }
}
